namespace Gamification.Gamification {
    export interface ApiForm {
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.StringEditor;
    }

    export class ApiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Api';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApiForm.init)  {
                ApiForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(ApiForm, [
                    'Nome', w0,
                    'Descrizione', w0
                ]);
            }
        }
    }
}
